module.exports = __webpack_public_path__ + "static/media/blank-page-icon.e547f7f8.svg";